import React, { useEffect, useState, Fragment, useMemo } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import * as Yup from "yup";

import $ from "jquery";

import WrapperPerfil from "../../../components/CompanyProfile/WrapperPerfil";

import icon_prfile from "../../../static/images/icon-prfile.png";
import portada from "../../../static/images/banner_default.png";
import defaultLogo from "../../../static/images/472.png";
import useOnceEffect from "../../../Hooks/useOnceEffect";
import { Insignias } from "../../Applicant/Perfil";
import { Url } from "../../../utils/Url/Url";
import ModalPut from "./ModalPut";
import ModalPost from "./ModalPost";

function PerfilEmpresaEdit({ reload }) {
  const [tab, settab] = useState(1);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [showPerfil, setshowPerfil] = useState(false);
  const [flag, setflag] = useState(false);

  const [activeTab, setactiveTab] = useState("tab-about");
  const [company, setcompany] = useState("");

  const [sectorList, setsectorList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [departmentId, setDepartmentId] = useState("");

  const userId = useMemo(() => localStorage.getItem("userId"), []);

  const ppBanner = {
    width: "100%",
    height: "100%",
  };

  const onClose = () => setshowPerfil(false);

  useOnceEffect(() => {
    axios.get("access/sector-list").then((result) => {
      setsectorList(result.data);
    });

    axios.get("department-list").then(({ data }) => setDepartments(data));
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    axios.get("access/company/" + userId).then((result) => {
      if (!result.data.name) {
        setLoading(true);
        setShow(true);
        return;
      }

      setcompany(result.data);
      setLoading(false);
    });
  }, [flag, userId]);

  function getMunicipality(id = 0) {
    if (id === 0 || isNaN(id)) return;

    axios
      .get(`access/municipalities?department=${id}`)
      .then(({ data }) => setMunicipalities(data));

    setDepartmentId(id);
  }

  function GuardarPerfil(values) {
    const perfil = {
      ...values,
      aboutUs: "",
      companyId: 0,
      genderPoliciesUs: "",
      mission: "",
      otroSector: "",
      valuesUs: "",
      urlVideo: "",
      departmentId,
      allies: values.allies ? 1 : 0,
    };

    axios.post("access/create-companyprofile", perfil).then((result) => {
      if (result.status === 200) {
        setflag(true);
        setShow(false);
        toast.success("Se ha creado su perfil exitosamente");
      }
    });
  }

  function ActualizarPerfil() {
    let banner = document.getElementById("profileImageUpdate");
    let formData = new FormData();
    let { companyProfileId } = company;

    formData.append("profileImage", banner.files[0]);

    axios
      .post(`access/create-companyphoto/${companyProfileId}`, formData)
      .then((result) => {
        if (result.status === 200) {
          reload();
          setflag(!flag);
          toast.success("Se ha actualizado su foto de perfil exitosamente");
          $("#actualizar-perfil-modal").modal("hide");
        }
      })
      .catch(() => {
        $("#actualizar-perfil-modal").modal("hide");
      });
  }

  function ActualizarPortada() {
    let banner = document.getElementById("bannerImageUpdate");
    let formData = new FormData();
    let { companyProfileId } = company;

    formData.append("bannerImage", banner.files[0]);

    axios
      .post(`access/create-companyphoto/${companyProfileId}`, formData)
      .then((result) => {
        if (result.status === 200) {
          setflag(!flag);
          toast.success("Se ha actualizado su foto de portada exitosamente");
          $("#actualizar-portada-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#actualizar-portada-modal").modal("hide");
      });
  }

  function ActualizarDatosPerfil(values) {
    const perfil = {
      ...values,
      departmentId,
      companyId: company.companyProfileId,
      allies: values.allies ? 1 : 0,
    };

    axios
      .post("access/update-companyprofile", perfil)
      .then(() => {
        setflag(!flag);
        setshowPerfil(false);
        toast.success("Se ha actualizado exitosamente");
      })
      .catch(function (error) {
        if (error?.response?.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error?.response?.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  }

  const Validaciones = Yup.object().shape({
    name: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    ubication: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    fundation: Yup.string().max(4, "No puede tener mas de 4 caracteres"),
  });

  function CallTab(id, li) {
    settab(id);

    let act = document.getElementById(activeTab);
    let newActive = document.getElementById(li);

    act.classList.remove("profile__tabs--active");
    newActive.classList.add("profile__tabs--active");

    setactiveTab(li);
  }

  function ReloadData() {
    setflag(flag ? false : true);
  }

  return (
    <div className="vacantes perfil-empresa profile">
      <Fragment>
        <div className="container">
          <div className="row">
            <div className="body-profile">
              <div className="profile__header">
                <div className="profile__header-container">
                  <div className="profile__cover-photo">
                    <img
                      id="bannerPic"
                      src={
                        company.coverImage !== null
                          ? company.coverImage
                          : portada
                      }
                      className="no-cover-image"
                      alt="No cover"
                      style={ppBanner}
                    ></img>
                    <a
                      href="#/"
                      className="btn btn--white"
                      id="Editportada"
                      data-bs-toggle="modal"
                      data-bs-target="#actualizar-portada-modal"
                      data-title="Portada"
                    >
                      Editar Portada
                    </a>
                  </div>
                  <div className="profile__header-info">
                    <div className="profile__header-info-left">
                      <div className="profile__header-info-left-wrapper">
                        <div className="profile__header-info-photo">
                          <img
                            src={
                              company.image !== null
                                ? company.image
                                : defaultLogo
                            }
                            alt="no cover"
                            style={{
                              maxHeight: "138px",
                              maxWidth: "135px",
                              width: "100%",
                              height: "100%",
                              borderRadius: "10px",
                              background: "#fff",
                            }}
                          ></img>
                          <a
                            id="modalphoto"
                            href="#/"
                            className="link"
                            data-bs-toggle="modal"
                            data-bs-target="#actualizar-perfil-modal"
                            data-title="Perfil"
                            style={{
                              position: "absolute",
                              left: "-20px",
                            }}
                          >
                            <img src={icon_prfile} alt="ico profile"></img>
                          </a>
                        </div>
                        <div className="profile__header-info-description">
                          <div className="profile__header-info-description-name">
                            {company.name}
                          </div>
                          <div className="profile__header-info-description-slogan">
                            {company.slogan}
                          </div>
                          <a
                            href="#"
                            className="btn--gradient btn--gradient-small py-2 px-3"
                            onClick={() => {
                              let host = window.location.hostname;
                              //in the case host having a port, include it in the url
                              if (window.location.port) {
                                host = host + ":" + window.location.port;
                              }
                              // Asegurarse de que el protocolo sea https
                              let protocol =
                                window.location.protocol === "htpps:"
                                  ? "https"
                                  : "http";
                              let finalUrl = `${protocol}://${host}/compartir/empresa/${company.companyProfileId}`;
                              let Title = `${company.name}`;
                              let body = `Te comparto la empresa ${company.name} en Krezco, la red social de desarrollo profesional`;
                              navigator.share({
                                title: Title,
                                url: finalUrl,
                                text: body,
                              });
                            }}
                          >
                            <i className="fas fa-share-alt text-white"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="profile__header-info-right">
                      <div className="profile__header-info-right-wrapper">
                        <div className="profile__header-info-right-button">
                          <a
                            href="#/"
                            className="btn btn--gray"
                            onClick={() => setshowPerfil(true)}
                          >
                            <i className="fas fa-plus"></i> Editar Perfil
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile__tabs ">
                <div className="container bordered-box">
                  <div className="row">
                    <div className="col col-md-12">
                      <div className="profile__tabs-items">
                        <ul>
                          <li
                            id="tab-about"
                            className="profile__tabs--active"
                            onClick={() => CallTab(1, "tab-about")}
                          >
                            Acerca de Nosotros
                          </li>
                          <li
                            id="tab-empleo"
                            onClick={() => CallTab(2, "tab-empleo")}
                          >
                            Empleos
                          </li>
                          <li
                            id="tab-formaciones"
                            onClick={() => CallTab(3, "tab-formaciones")}
                          >
                            Formaciones
                          </li>
                          <li
                            id="tab-eventos"
                            onClick={() => CallTab(7, "tab-eventos")}
                          >
                            Eventos
                          </li>
                          <li
                            id="tab-fotosvideos"
                            onClick={() => CallTab(5, "tab-fotosvideos")}
                          >
                            Fotos / Videos
                          </li>
                          <li
                            id="tab-valoraciones"
                            onClick={() => CallTab(6, "tab-valoraciones")}
                          >
                            Buenas Practicas
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <label className="login-label">CARGANDO</label>
        ) : (
          <div className="container">
            <div className="row vacancy__content">
              <div className="col-12 col-md-5">
                <div className="_no profile__header">
                  <Insignias />
                </div>

                <div
                  className="vacancy__sidebar bordered-box"
                  style={{ marginTop: "0px" }}
                >
                  <div className="bordered-box__header">
                    <div className="bordered-box__header-title">
                      Información
                    </div>
                  </div>
                  <div className="vacancy__sidebar-content">
                    <ul>
                      <li>
                        <strong>Sitio Web:</strong>{" "}
                        <a
                          href={Url(company.webSite)}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {Url(company.webSite)}
                        </a>
                      </li>
                      <li>
                        <strong>Sector:</strong> {company.sectorId.name}
                      </li>
                      <li>
                        <strong>Dirección:</strong> {company.ubication}
                      </li>

                      <li>
                        <strong>Departamento:</strong>{" "}
                        {company?.departmentId?.name}
                      </li>

                      <li>
                        <strong>Municipio:</strong>{" "}
                        {company?.municipalityId?.name}
                      </li>
                      <li>
                        <strong>Año de Fundación:</strong> {company.fundation}
                      </li>
                      <li>
                        <strong>Empleados:</strong> {company.employes}
                      </li>
                    </ul>

                    <ul className="social-media">
                      {company.linkTwitter && (
                        <li>
                          <a href={Url(company.linkTwitter) ?? ""}>
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                      )}

                      {company.linkFacebook && (
                        <li>
                          <a href={Url(company.linkFacebook) ?? ""}>
                            <i className="fab fa-facebook"></i>
                          </a>
                        </li>
                      )}

                      {company.linkInstagram && (
                        <li>
                          <a href={Url(company.linkInstagram) ?? ""}>
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-7">
                <WrapperPerfil
                  id={tab}
                  company={company}
                  reload={ReloadData}
                ></WrapperPerfil>
              </div>
            </div>
          </div>
        )}

        {/*Actualizar portada image */}
        <div
          id="actualizar-perfil-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="form__row">
                      <div className="col-sm-12 col-md-8">
                        <input
                          id="profileImageUpdate"
                          type="file"
                          required
                        ></input>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        onClick={ActualizarPerfil}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Actualizar Perfil
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Actualizar Perfil image */}
        <div
          id="actualizar-portada-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="form__row">
                      <div className="col-sm-12 col-md-8">
                        <input
                          id="bannerImageUpdate"
                          type="file"
                          required
                        ></input>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        onClick={ActualizarPortada}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Actualizar Portada
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalPost
          show={show}
          Validaciones={Validaciones}
          sectorList={sectorList}
          departments={departments}
          municipalities={municipalities}
          getMunicipality={getMunicipality}
          GuardarPerfil={GuardarPerfil}
          departmentId={departmentId}
        />

        <ModalPut
          showPerfil={showPerfil}
          onClose={onClose}
          company={company}
          Validaciones={Validaciones}
          sectorList={sectorList}
          departments={departments}
          municipalities={municipalities}
          getMunicipality={getMunicipality}
          ActualizarDatosPerfil={ActualizarDatosPerfil}
          departmentId={departmentId}
        />
      </Fragment>
    </div>
  );
}

export default PerfilEmpresaEdit;
